import Container from "@/components/commons/Container";
import { ProductSlug } from "@/api/product-api";
import Image from "next/image";
import { useTrans } from "@/utils/useTrans";
import { cn } from "@/libs/utils";

const AtHImages = {
  [ProductSlug.TACTSUIT_PRO]: {
    desktop: "/images/tactsuit/audio-to-haptic-banner_desktop.jpg",
    mobile: "/images/tactsuit/audio-to-haptic-banner_mobile.jpg",
  },
  [ProductSlug.TACTSUIT_AIR]: {
    desktop: "/images/tactsuit/tactsuit-air/audio-to-haptic-banner_desktop.jpg",
    mobile: "/images/tactsuit/tactsuit-air/audio-to-haptic-banner_mobile.jpg",
  },
  [ProductSlug.TACTSLEEVE]: {
    desktop: "/images/tactsuit/tactsleeve/audio-to-haptic-banner_desktop.png",
    mobile: "/images/tactsuit/tactsleeve/audio-to-haptic-banner_mobile.png",
  },
  default: {
    desktop: "/images/tactsuit/audio-to-haptic-banner_desktop.jpg",
    mobile: "/images/tactsuit/audio-to-haptic-banner_mobile.jpg",
  },
};

interface Props {
  slug: string;
  className?: string;
}

export function AudioToHapticSection({ slug, className }: Props) {
  const { t } = useTrans(["tactsuit"]);

  const { desktop, mobile } = AtHImages[slug] ?? AtHImages["default"];

  return (
    <div
      className={cn(
        "relative mt-16 w-full bg-coolgray-10 laptop:mt-24 laptop:h-[800px] laptop:px-4",
        className,
      )}
    >
      <div className="relative h-[360px] w-full laptop:absolute laptop:inset-0 laptop:h-[800px]">
        <Image
          src={desktop}
          alt={"Image"}
          className="hidden object-cover laptop:flex"
          fill
          sizes="100vw"
        />
        <Image
          src={mobile}
          alt={"Image"}
          className="block object-cover laptop:hidden"
          fill
          sizes="100vw"
        />
      </div>
      <Container className="max-w-screen-mdl pb-8 pt-6 laptop:absolute laptop:top-1/2 laptop:-translate-y-1/2 laptop:bg-transparent laptop:p-0">
        <div className="flex w-full max-w-[368px] flex-col gap-3 laptop:gap-5">
          <h2 className="text-3xl laptop:text-5xl">
            {t("Powerful Haptics for Music")}
          </h2>
          <p className="text-base laptop:whitespace-pre-line laptop:text-lg">
            {t(
              `Feel every beat with audio haptics and immerse your whole body in rhythm games with precise feedback.`,
            )}
          </p>
        </div>
      </Container>
    </div>
  );
}
